// Header inside a DataCard. Shows a title (centered on the entire card)
// with action buttons pinned to the right on the same line at every width.
// Optional belowText renders on a second row beneath the title.
//
// Props:
//   text          — title of the card
//   belowText     — subtitle below the title
//   deleteTapped  — onClick for the Delete button; omit to hide
//   editTapped    — onClick for the Edit button; omit to hide
//   emailTapped   — onClick for the email icon button; omit to hide
//   seeAllTapped  — onClick for the See All button; omit to hide
//   addTapped     — onClick for the Add button; omit to hide
//   addText       — label for the Add button (defaults to 'Add')
//   shareTapped   — onClick for the share icon button; omit to hide
//   extraActions  — arbitrary node rendered first in the actions row (e.g. a
//                   dropdown of secondary actions); omit to hide

import Button from 'react-bootstrap/Button';

export const CardHeader = ({
  text,
  belowText,
  deleteTapped,
  editTapped,
  emailTapped,
  seeAllTapped,
  addTapped,
  addText,
  shareTapped,
  extraActions,
}) => (
  <div className="card-header-row">
    <div className="card-header-top position-relative d-flex align-items-center">
      <div className="card-header-title w-100 text-center">
        <h5 className="mb-0 fw-semibold">{text}</h5>
      </div>

      <div className="card-header-actions d-flex justify-content-end gap-2 flex-wrap">
        {extraActions}
        {emailTapped && (
          <Button variant="outline-secondary" onClick={emailTapped} aria-label="Email">
            <i className="fa-regular fa-envelope" aria-hidden="true"></i>
          </Button>
        )}
        {shareTapped && (
          <Button variant="outline-secondary" onClick={shareTapped}>Share</Button>
        )}
        {seeAllTapped && (
          <Button variant="outline-primary" onClick={seeAllTapped}>See All</Button>
        )}
        {editTapped && (
          <Button variant="primary" onClick={editTapped}>Edit</Button>
        )}
        {deleteTapped && (
          <Button variant="outline-danger" onClick={deleteTapped}>Delete</Button>
        )}
        {addTapped && (
          <Button variant="success" onClick={addTapped}>
            <i className="fa-solid fa-plus me-1" aria-hidden="true"></i>
            {addText || 'Add'}
          </Button>
        )}
      </div>
    </div>

    {belowText && (
      <div className="card-header-below text-body-secondary small mt-3 text-center">
        {belowText}
      </div>
    )}
  </div>
);

export default CardHeader;
